import {appConfig, EAppMode} from "./app";

const serverAddress: string =
  appConfig.mode === EAppMode.DEBUG ?
    `n/${window.location.hostname}/3222` :
    `s/${window.location.hostname}`; // is the same with one of server's process.env.APP_EXTERNAL_ADDRESSES

export const serviceAddress = (serviceName: string): string => `${serviceName}@${serverAddress}`;
